import { render, staticRenderFns } from "./liveCourse.vue?vue&type=template&id=507e20ca&scoped=true"
import script from "./liveCourse.vue?vue&type=script&lang=ts"
export * from "./liveCourse.vue?vue&type=script&lang=ts"
import style0 from "./liveCourse.vue?vue&type=style&index=0&id=507e20ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507e20ca",
  null
  
)

export default component.exports